import React, {useEffect, useState, ComponentPropsWithoutRef} from "react";
import styles from "./fullpage.module.css";
import {DownloadVideoModal} from "../../components/MenuOptions";
import eventEmitter from "../../utils/eventEmitter";
import useSocket from "../../hooks/useSocket";
import {PortalScope} from "../../hooks/PortalScopeContext";

export function LayoutFullPage({children}: ComponentPropsWithoutRef<"div">) {
    // const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    // const [downloadLink, setDownloadLink] = useState("");
    // const socket = useSocket();

    //   useEffect(() => {

    //     const handleDownload = (param: { fileName: string }) => {
    //       try {
    //         setDownloadLink(param.fileName);
    //         setDownloadModalOpen(true);
    //       } catch {
    //         // swallow parse errors
    //       }
    //     };

    //     eventEmitter.on('download', handleDownload);

    //     return () => {
    //       eventEmitter.off('download', handleDownload);
    //     };
    //   }, []);

    // Every route wrapped in this layout is a public / share / auth surface
    // outside the brand-portal URL space, so shared components must not prefix
    // their links here even when the viewer is a logged-in brand user
    // (see hooks/PortalScopeContext).
    return (
        <PortalScope basePath="">
            <div className={styles["fullpage-container"]}>{children}</div>
            {/* <DownloadVideoModal
        open={downloadModalOpen}
        onClose={() => {
          setDownloadModalOpen(false);
          setDownloadLink('');
        }}
        downloadSource={downloadLink}
      />   */}
        </PortalScope>
    );
}
